import { render, staticRenderFns } from "./BlrSelect.vue?vue&type=template&id=0fe311dd&"
import script from "./BlrSelect.vue?vue&type=script&lang=js&"
export * from "./BlrSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports